import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

import { environment } from 'admin/../environments/environment';
import { CurrentUserService } from 'admin/core/auth/current-user.service';

export const unauthorizedInterceptor: HttpInterceptorFn = (request, next) => {
  const router = inject(Router);
  const currentUser = inject(CurrentUserService);

  return next(request).pipe(
    catchError((error: unknown) => {
      if (
        request.url.startsWith(environment.apiUrl) &&
        error instanceof HttpErrorResponse &&
        error.status === 401
      ) {
        currentUser.clear();
        void router.navigateByUrl('/auth/login', { replaceUrl: true });
      }

      return throwError(() => error);
    }),
  );
};
